// TODO: In 2025 remove this module and just use crypto.randomUUID();

/**
 * NOTICE!!!
 * This will only work in a browser context
 * If you are working in a Node context then require('node:crypto'); and use crypto.randomUUID(); directly
 *
 */
// returns a v4 uuid
export function uuidv4() {
  if (self && self.crypto) {
    // crypto exists:
    if (self.crypto.randomUUID) {
      // crypto.randomUUID exists:
      return self.crypto.randomUUID();
    } else if (self.crypto.getRandomValues) {
      // crypto.getRandomValues exists:
      // credit: https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid (top answer)
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
      );
    } else {
      // crypto.randomUUID and crypto.getRandomValues do not exist:
      throw new Error('crypto.randomUUID and crypto.getRandomValues do not exist! This module only works in a browser context.');
    }
  } else {
    // crypto does not exist:
    throw new Error('crypto does not exist! This module only works in a browser context.');
  }
}
